module.exports = __webpack_public_path__ + "static/media/map.e5a40f79.svg";